export default "__VITE_ASSET__CHUDBr0H__"